angular.module('pentaApp').factory("identification.factory", factory);
factory.$inject = [];
function factory() {
  return window.identificationUtils; // esto está en src/utils/identificationUtils, importado desde includes
}
